<mat-sidenav-container class="sidenav-container">

    <mat-sidenav #drawer class="sidenav bg-primary" fixedInViewport
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [opened]="(isHandset$ | async) === false">

        <app-menu></app-menu>

    </mat-sidenav>

    <mat-sidenav-content>

        <mat-toolbar>

            @if (isHandset$ | async) {


                <a mat-button matTooltip="Customers lookup" aria-label="Toggle sidenav" (click)="drawer.toggle()">
                    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
                </a>

                <span class="pad"></span>
            }

            <div class="compressed buc">HDesk</div>

            <span class="spacer"></span>

            <a mat-button matTooltip="Tickets lookup" aria-label="Customers lookup" routerLink="/tickets">
                <mat-icon>search</mat-icon>
            </a>

            <span class="pad"></span>

            <a mat-button matTooltip="My account" aria-label="My account" routerLink="/account">
                <mat-icon>person_outline</mat-icon>
            </a>

            <span class="pad"></span>

            <a mat-button matTooltip="Help" aria-label="help" routerLink="/help">
                <mat-icon>help_outline</mat-icon>
            </a>

            <span class="pad"></span>

            <a mat-button matTooltip="Logout" aria-label="Logout" (click)="logout()">
                <mat-icon>power_settings_new</mat-icon>
            </a>

        </mat-toolbar>

        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <span class="compressed buc">{{ws.title()}}<br /><small>{{ws.subtitle()}}</small></span>
            </mat-toolbar-row>
        </mat-toolbar>

        <!-- Add Content Here -->
        <router-outlet  (activate)="ws.clean()"></router-outlet>

    </mat-sidenav-content>

</mat-sidenav-container>